export default __webpack_public_path__ + "static/media/sad.54b35ffe.mp3";